
    const data = {"name":"src/core/icons/shape-plus","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M2 2h9v9H2V2m15.5 0C20 2 22 4 22 6.5S20 11 17.5 11 13 9 13 6.5 15 2 17.5 2m-11 12 4.5 8H2l4.5-8M19 17h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            